import React, { createContext, useState, useContext } from "react";

const CategoriaContext = createContext();

export function useCategoria() {
  return useContext(CategoriaContext);
}

export function CategoriaProvider({ children }) {
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("Todo");
  return (
    <CategoriaContext.Provider value={{ categoriaSeleccionada, setCategoriaSeleccionada }}>
      {children}
    </CategoriaContext.Provider>
  );
} 